import patternImage from "@/public/images/stamp.png";
import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import { Fire } from "@phosphor-icons/react";
import Image from "next/image";

export default function SpecialOfferText() {
  return (
    <Flex className="absolute gap-2 md:h-[140px] max-md:translate-x-2 max-md:absolute top-1 md:top-3 max-md:left-1 md:translate-x-3 rounded-b-xl z-10 max-md:hidden">
      <Flex className="relative pt-3 md:pt-7">
        <Image
          src={patternImage}
          alt="stamp"
          height={1000}
          width={1000}
          className="top-0 absolute right-0 scale-150 max-md:hidden"
        />
        <Typography
          variant="body1"
          className="md:text-red-500 max-md:flex max-md:items-center max-md:gap-1  !font-semibold md:-rotate-16 md:translate-x-4 max-md:bg-secondary max-md:h-max max-md:p-2  max-md:text-sm max-md:rounded-full "
        >
          پیشنهاد ویژه
          <Fire className="md:hidden w-5 h-5" weight="bold" />
        </Typography>
      </Flex>
    </Flex>
  );
}
